// @flow
import { PRODUCT_EXCLUSIVE_COLLECTION_SPACE } from 'Client/cms/toolkit/constants';
import gqlClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_EXCLUSIVE_COLLECTION_SPACE } from 'Utils/request/requestDictionary';

export const productExclusiveCollectionSpaceResolver = {
  name: PRODUCT_EXCLUSIVE_COLLECTION_SPACE,
  resolve(appContext: AppContext) {
    const query = `query {
      config {
        common {
          viewMore
          loadLess
        }
      }
    }`;

    return gqlClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_EXCLUSIVE_COLLECTION_SPACE,
      strictErrors: false,
    });
  },
};
